import map from "lodash/map";
export default {
  getShowById: state => id => {
    return state.shows.find(show => show.id === id);
  },
  editSlideArray: state => {
    if (!state.currentShowDetails) {
      return [];
    }
    return state.currentShowDetails.data.slideArray;
  },
  editOverlayArray: state => {
    if (!state.currentShowDetails) {
      return [];
    }
    // Ensure that all overlays have a type.
    var overlays = map(state.currentShowDetails.data.overlayArray, o => {
      if (!o.type) {
        o.type = "lowerthird";
      }
      return o;
    });
    return overlays;
  },
  editDisplaySettings: state => {
    if (!state.currentShowDetails) {
      return {};
    }
    return state.currentShowDetails.data.displaySettings;
  },
  browserName: state => {
    if (state.bowser) {
      return state.bowser.getBrowserName();
    }
    return "";
  },
  timelinePushMode: state => {
    if (!state.currentShowDetails) {
      return false;
    }
    return state.currentShowDetails.data.displaySettings.timelinePushMode;
  },
  globalTimelineElasticMode: state => {
    if (!state.currentShowDetails) {
      return false;
    }
    return state.currentShowDetails.data.displaySettings
      .globalTimelineElasticMode;
  }
};
